module.exports = "/_next/static/files/c02d68a3ad7c68bf5d35633c8b3a0a83.jpg";